
import Modal from '@/interfaces/modal'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Vue, Options } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'


@Options({
  components: {
    FontAwesomeIcon
  },
  emits: ['removeModal']
})

export default class NewModalRightFullPage extends Vue {
  @Prop({ required: true, type: Array }) readonly modals!: Modal[]

  closeModal(modal: Modal) {
    modal.state = 'closed'
    setTimeout(() => {
      this.removeModal(modal)
    }, 300)
  }
  
  removeModal(modal: Modal) {
    this.$emit('removeModal', modal)
  }
}
